/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_OtherInputs */

const en_us2_onboarding_how_heard_other = /** @type {(inputs: Onboarding_How_Heard_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const pt_br2_onboarding_how_heard_other = /** @type {(inputs: Onboarding_How_Heard_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const es_419_onboarding_how_heard_other = /** @type {(inputs: Onboarding_How_Heard_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const pt_pt2_onboarding_how_heard_other = /** @type {(inputs: Onboarding_How_Heard_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const fr_fr2_onboarding_how_heard_other = /** @type {(inputs: Onboarding_How_Heard_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const de_de2_onboarding_how_heard_other = /** @type {(inputs: Onboarding_How_Heard_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere`)
};

const it_it2_onboarding_how_heard_other = /** @type {(inputs: Onboarding_How_Heard_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Onboarding_How_Heard_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_other = /** @type {((inputs?: Onboarding_How_Heard_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_other(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_other(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_other(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_other(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_other(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_other(inputs)
	return en_us2_onboarding_how_heard_other(inputs)
});
export { onboarding_how_heard_other as "onboarding.how_heard.other" }